var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-cards-section',{staticClass:"link-cards-module",attrs:{"title":_vm.attributes.linkCards_title,"slides":_vm.formattedSlides,"show-navigation-buttons":_vm.attributes.linkCardsSection_show_navigation_buttons}})}
var staticRenderFns = []

export { render, staticRenderFns }